// Operator info — referenced by every legal document.
// Fill in the placeholders before publishing the site publicly.

export const OPERATOR = {
  // The legal documents intentionally use the product name ("Inverow") rather
  // than the operator's personal name to avoid putting it on every public page.
  // Identity can still be verified through the domain registrar / support email.
  country:      'Czech Republic',
  supportEmail: 'support@inverow.com',
  productName:  'Inverow',
  productUrl:   'https://inverow.com',
  effectiveDate: '2026-05-18',
};

// All third parties that process user data on Inverow's behalf.
// Update when you add/remove a service. Surface on /subprocessors page.
export const SUBPROCESSORS = [
  { name: 'Railway',         purpose: 'PostgreSQL database and backend API hosting', region: 'Singapore',     url: 'https://railway.com/legal/privacy' },
  { name: 'Vercel',           purpose: 'Frontend hosting and CDN',                    region: 'USA (global)',  url: 'https://vercel.com/legal/privacy-policy' },
  { name: 'Resend',           purpose: 'Transactional email delivery (registration, password reset)', region: 'USA', url: 'https://resend.com/legal/privacy-policy' },
  { name: 'Yahoo Finance',    purpose: 'Market data (prices, dividends, fundamentals)', region: 'USA',         url: 'https://legal.yahoo.com/us/en/yahoo/privacy/' },
  { name: 'Frankfurter.app',  purpose: 'Historical foreign exchange rates',           region: 'EU',            url: 'https://www.frankfurter.app/' },
  { name: 'Financial Modeling Prep', purpose: 'Instrument fundamentals (PE, dividend yield)', region: 'USA', url: 'https://site.financialmodelingprep.com/privacy-policy' },
  { name: 'Logo.dev',         purpose: 'Company logos shown next to holdings',        region: 'USA',           url: 'https://logo.dev/privacy' },
];
